import { TextField } from "@mui/material";
import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import styles from "./forgotpasswordcodecheck.module.css";
import Loader from "../../../admin/components/Loader";
import { Home } from "react-feather";

const ForgotPasswordCodeCheck = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const { register, handleSubmit, control, setValue, formState: { errors } } = useForm({
    mode: "onChange",
  });

  useEffect(() => {
    if (localStorage.getItem("passwordemail")) {
      setValue("email", localStorage.getItem("passwordemail"));
    }
  }, [setValue]);

  async function onSubmit(data) {
    const postData = data;
    setLoading(true);
    setErrorMsg("");
    setSuccessMsg("");
    return axios.post(process.env.REACT_APP_API_URL + "v1/forgot-password/code/check", postData).then((response) => {
      setLoading(false);
      if (response.data.status === "SUCCESS") {
        const resData = response.data;
        setSuccessMsg(resData.message);
        localStorage.setItem("passwordToken", resData?.token);
        setTimeout(() => {
          navigate("/forgot-password-change");
        }, 3000);
      }
      if (response.data.status === "ERROR") {
        setErrorMsg(response?.data?.message);
      }
    }).catch((error) => {
      if (error && error?.response && error?.response?.data && error?.response?.data?.message) {
        setErrorMsg(error?.response?.data?.message);
      }
      setLoading(false);
    });
  }

  return (<>
    <Loader open={loading} setOpen={setLoading.bind(this)} />
    <div className={`${styles.MainDiv}`}>
      <div className={`${styles.LoginFormSec}`}>
        <div className={`${styles.LohinForm}`}>
          <Link to={"/"} className={`${styles.BackHomeBU}`}><Home />Back to home</Link>
          <h2 className={`${styles.BookingFormTitle} ${styles.Heading}`}>Forgot Password</h2>
          <p className={`${styles.LoginformSmTitle}`}>Reset Your Password</p>

          <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
            <p className={`${styles.SuccessM}`}>{successMsg}</p>
            <p className={`${styles.ErrorM}`}>{errorMsg}</p>
            <div className={`${styles.FormRow}`}>
              <div className={`${styles.FormGroup} FormGroup`}>
                <Controller
                  control={control}
                  {...register("email", {
                    required: "This field is Required",
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: "Invalid email address",
                    },
                  })}
                  render={({ field }) => (<TextField {...field} label="Email*" variant="outlined" InputProps={{ readOnly: true }} />)}
                />
                {errors.email && (<span className={`${styles.ErrorM}`}>{errors.email.message}</span>)}
              </div>

              <div className={`${styles.FormGroup} FormGroup`}>
                <Controller
                  control={control}
                  {...register("token", {
                    required: "This field is Required",
                  })}
                  render={({ field }) => (<TextField {...field} label="Please enter code*" variant="outlined" />)}
                />
                {errors.token && (<span className={`${styles.ErrorM}`}>{errors.token.message}</span>)}
              </div>
              <Link to={"/sign-in"} className={`${styles.ForhotPassText}`}>Login</Link>
            </div>
            <button type="submit" className={`${styles.LoginBU}`}>
              <span>Submit</span>
            </button>
          </form>
        </div>
      </div>

      <div className={`${styles.LoginBGSec}`}>
        <img src="/images/loginBG1.jpg" alt="" />
      </div>
    </div>
  </>);
};

export default ForgotPasswordCodeCheck;